import React from 'react';
import '../../globals.scss';

interface AuthHeaderProps {
  header: string;
  styleName: string;
  source?: string;
  width?: number;
  height?: number;
  link?: string;
  signup?: boolean;
  login?: boolean;
}

export default function AuthHeader(props: AuthHeaderProps): React.ReactElement {
  const { header, styleName, signup, link, login, source, width, height } =
    props;
  const conditionalStyling = signup ? 'Signup' : 'Login';
  return (
    <div className={conditionalStyling}>
      {/*{!signup && (*/}
      {/*  <Link href="/">*/}
      {/*    <ImageComponent*/}
      {/*      source={'../../public/logo-placeholder.png'}*/}
      {/*      alt="logo click and go back home"*/}
      {/*      priority={false}*/}
      {/*      width={width}*/}
      {/*      height={height}*/}
      {/*    />*/}
      {/*  </Link>*/}
      {/*)}*/}
      {signup && <h2 className={styleName}>{header}</h2>}
      {login && <h2 className={styleName}>{header}</h2>}
    </div>
  );
}
